import React, { useContext } from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import TextualContent from '../../DeviationViews/TextualContent';
import DesktopLayout from '../_partials/DesktopLayout';
import StageBackground from '../../DeviationBackground/StageBackground';
import PanelPopup from '../_partials/PanelPopup';
import { ScreenSizeContext } from '../../Measured';
import s from './DesktopTierPage.scss';
const DesktopTierPage = ({ deviation  })=>{
    const { width: screenSize  } = useContext(ScreenSizeContext);
    return /*#__PURE__*/ React.createElement(DesktopLayout, {
        deviation: deviation,
        stageContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ArtStage, {
            deviation: deviation,
            className: s['art-stage']
        }), /*#__PURE__*/ React.createElement(ActionBar, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(PanelPopup, {
            deviation: deviation,
            className: s['large-popover'],
            actionBarType: "primary"
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['content']
        }, /*#__PURE__*/ React.createElement(TextualContent, {
            deviation: deviation
        }))),
        metaContent: /*#__PURE__*/ React.createElement(Details, {
            className: s['content'],
            deviation: deviation
        }),
        backgroundContent: /*#__PURE__*/ React.createElement(StageBackground, {
            deviation: deviation,
            width: Math.max(screenSize, 780)
        })
    });
};
DesktopTierPage.displayName = 'DesktopTierPage';
export default DesktopTierPage;
